var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_191_768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1842 6.23697C13.1842 6.46585 13.1842 7.21184 13.1842 8.27167H16.8281L16.433 11.5199H13.1842C13.1842 16.5294 13.1842 23.2423 13.1842 23.2423H8.87198C8.87198 23.2423 8.87198 16.6183 8.87198 11.5199H6.625V8.27167H8.87198C8.87198 6.98349 8.87198 6.0675 8.87198 5.81246C8.87198 4.5973 8.78043 4.02074 9.29676 3.07911C9.81335 2.13752 11.2705 0.89293 13.7907 0.922894C16.3116 0.95395 17.3741 1.19646 17.3741 1.19646L16.8281 4.65832C16.8281 4.65832 15.2184 4.23328 14.4283 4.38476C13.6392 4.53628 13.1842 5.02235 13.1842 6.23697Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_191_768"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.0825195)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.f3ecd8cd626c551f4f0d0d07ed102ead.svg";
export { ForwardRef as ReactComponent };